if (!customElements.get("paginate-button")) {
  customElements.define(
    "paginate-button",
    class PaginateButton extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.collectionPaginate = this.closest("collection-paginate");
        this.addEventListener("click", this.buttonClick.bind(this));
        this.addEventListener("keyup", this.buttonKeyboard.bind(this));
      }

      buttonClick() {
        const currentPage = parseInt(this.collectionPaginate.currentPage);
        const totalPages = parseInt(this.collectionPaginate.totalPages);

        this.innerHTML = "Loading...";

        this.collectionPaginate.extendPage();
      }
      buttonKeyboard(e) {
        if (e.keyCode == 32 || e.keyCode == 13) {
          this.innerHTML = "Loading...";
          this.collectionPaginate.extendPage();
        }
      }
    }
  );
}

if (!customElements.get("collection-paginate")) {
  customElements.define(
    "collection-paginate",
    class CollectionPaginate extends HTMLElement {
      constructor() {
        super();

        this.init();
        this.availableCollectionJson = JSON.parse(
          document.querySelector("#availble-collection").textContent
        );
      }

      init() {
        // 1) Prefer state from filter-tabs (JS source of truth)
        const filterTabs = document.querySelector('filter-tabs');
        let tagsFromTabs = [];

        if (filterTabs) {
          const activeButtons = filterTabs.querySelectorAll('filter-button.filter-active');
          tagsFromTabs = Array.from(activeButtons)
            .map(btn => btn.dataset.value)
            .filter(Boolean);
        }

        // 2) Fallback: JSON from #activeFiltersJson (works on plain collection, but usually empty on /search)
        let tagsFromJson = [];
        const jsonScript = this.querySelector('#activeFiltersJson');
        if (jsonScript) {
          try {
            const data = JSON.parse(jsonScript.textContent || jsonScript.innerHTML || '{}');
            console.log('this.activeFiltersJson', data);
            tagsFromJson = (data.tags || []).map(tagData => tagData.tag).filter(Boolean);
          } catch (e) {
            console.error('Failed to parse #activeFiltersJson', e);
          }
        }

        // 3) Only set activetags if we actually found something
        if (!this.activetags || !Array.isArray(this.activetags) || this.activetags.length === 0) {
          this.activetags = tagsFromTabs.length > 0 ? tagsFromTabs : tagsFromJson;
        }

        if (!Array.isArray(this.activetags)) {
          this.activetags = [];
        }

        console.log('this.activetags (after init)', this.activetags);


        this.collectionUrl = this.dataset.collUrl;
        this.collectionHandle = this.getAttribute("collection-handle"); // Store handle

        // necessary html components
        this.activeFiltersContainers = document.querySelectorAll(".active--collection-filters");
        this.prodGridContainer = this.querySelector("#ProductGridContainer");

        // components for plp pagination
        this.plpContainer = this.querySelector(".collection");
        this.currentPage = parseInt(this.plpContainer.dataset.currentPage);
        this.totalPages = parseInt(this.plpContainer.dataset.totalPages);
        this.prodGrid = this.plpContainer.querySelector("#product-grid");
        this.paginateIndicator = this.plpContainer.querySelector(".paginate-indicator");
      }

      connectedCallback() {
        this.renderActiveFilters(this.activetags);
        this.updateViewMoreCount();
      }

      showLoadingMotion() {
        return `
        <div class="loading-motion">
          <img src="//cdn.shopify.com/s/files/1/0035/0306/3153/files/loading.gif?v=1661369501" loading="lazy" width="150" alt="loading-icon">
        </div>
      `;
      }

      renderActiveFilters(tags) {
        const collectionHandle = this.getAttribute("collection-handle");

        const newHTML =
          tags.length > 0
            ? `
            <p>Filter By</p>
            <div class="active--collection-filters__container">
              <ul class="active-filters__list">
                ${collectionHandle === "baby" ||
              collectionHandle === "shop-all" ||
              collectionHandle === "kids"
              ? tags
                .map((tag) => {
                  const tagData = tag.split("_");
                  return `<li><remove-filter role="button" tabindex="0" class="active-filter" data-filter-value=${tag}>${tagData[0] === "size" ? tagData[1] : ""
                    } x</remove-filter></li>`;
                })
                .join("")
              : tags
                .map((tag) => {
                  const tagData = tag.split("_");
                  return `<li><remove-filter role="button" tabindex="0" class="active-filter" data-filter-value=${tag}>${tagData[0] === "size"
                    ? tagData[1].replace("-", ".")
                    : tagData[1].replace("&", " & ").replace("$", " $")
                    } x</remove-filter></li>`;
                })
                .join("")
            }
              </ul>
              <remove-filter role="button" tabindex="0" id="resetFilters" data-filter-value="clear">
                Clear Filters
              </remove-filter>
            </div>
          `
            : "";

        this.activeFiltersContainers.forEach(container => {
          container.innerHTML = newHTML;
        });
      }

      filterProductsByCollection(wrapper) {
        if (!this.collectionHandle || this.collectionHandle === 'all') return;

        const products = wrapper.querySelectorAll('#product-grid .grid__item');
        products.forEach(product => {
          const handles = product.dataset.collectionHandles;
          if (handles && !handles.split(',').includes(this.collectionHandle)) {
            product.remove();
          }
        });
      }

      updateViewMoreCount() {
        if (!this.prodGrid || !this.paginateIndicator) return;

        const btn = this.paginateIndicator.querySelector('.paginate-more');
        if (!btn) return;

        const totalCount = parseInt(btn.dataset.totalCount, 10);
        if (!Number.isFinite(totalCount)) return;

        const loadedCount = this.prodGrid.querySelectorAll('.grid__item').length;
        const countSpan = btn.querySelector('.view-more-count');

        if (countSpan) {
          countSpan.textContent = `${loadedCount}/${totalCount}`;
        }
      }

      async fetchFilterProdList() {
        const selected = this.activetags;
        const hasFilters = Array.isArray(selected) && selected.length > 0;

        if (!hasFilters) {
          const url = this.collectionUrl;
          history.replaceState({}, "current_filter", url);

          this.prodGridContainer.innerHTML = this.showLoadingMotion();

          try {
            const html = await fetch(url).then((response) => response.text());
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;

            const newCollectionPaginate = wrapper.querySelector('collection-paginate');
            const newPaginationRow = wrapper.querySelector('.pagination-row[data-ajax-container]');
            const currentCollectionPaginate = document.querySelector('collection-paginate');
            const currentPaginationRow = document.querySelector('.pagination-row[data-ajax-container]');

            if (newCollectionPaginate && currentCollectionPaginate) {
              const savedHandle = this.getAttribute("collection-handle");
              const savedUrl = this.dataset.collUrl;

              currentCollectionPaginate.innerHTML = newCollectionPaginate.innerHTML;

              if (savedHandle) this.setAttribute("collection-handle", savedHandle);
              if (savedUrl) this.dataset.collUrl = savedUrl;

              this.init();
              this.renderActiveFilters([]);
            }

            if (newPaginationRow && currentPaginationRow) {
              currentPaginationRow.innerHTML = newPaginationRow.innerHTML;
            }
          } catch (err) {
            console.error(err);
          }

          return;
        }

        const searchQuery = selected.map(tag => `tag:${tag}`).join(' OR ');
        console.log('searchQuery', searchQuery);

        const tmpUrl = `/search?q=${encodeURIComponent(searchQuery)}&type=product&view=ajax`;
        console.log('tmpUrl', tmpUrl);

        const url = `${this.collectionUrl}/${this.activetags.join("+")}`;
        history.replaceState({}, "current_filter", url);

        // show loading
        this.prodGridContainer.innerHTML = this.showLoadingMotion();

        try {
          const prodList = await fetch(tmpUrl).then((response) => response.text());
          const wrapper = document.createElement('div');
          wrapper.innerHTML = prodList;

          // Filter out products not in current collection
          this.filterProductsByCollection(wrapper);

          const newCollectionPaginate = wrapper.querySelector('collection-paginate');
          const newPaginationRow = wrapper.querySelector('.pagination-row[data-ajax-container]');
          const currentCollectionPaginate = document.querySelector('collection-paginate');
          const currentPaginationRow = document.querySelector('.pagination-row[data-ajax-container]');

          if (newCollectionPaginate && currentCollectionPaginate) {
            // Preserve critical attributes before overwriting
            const savedHandle = this.getAttribute("collection-handle");
            const savedUrl = this.dataset.collUrl;

            currentCollectionPaginate.innerHTML = newCollectionPaginate.innerHTML;

            // Restore attributes
            if (savedHandle) this.setAttribute("collection-handle", savedHandle);
            if (savedUrl) this.dataset.collUrl = savedUrl;

            // Re-wire refs to new children, but KEEP this.activetags
            this.init();

            // After init, re-render active filters based on current tags
            this.renderActiveFilters(this.activetags || []);
            this.updateViewMoreCount();
          }

          if (newPaginationRow && currentPaginationRow) {
            currentPaginationRow.innerHTML = newPaginationRow.innerHTML;
          }
        } catch (err) {
          console.error(err);
        }
      }

      async extendPage() {
        if (this.currentPage >= this.totalPages) return;

        const hasFilters = Array.isArray(this.activetags) && this.activetags.length > 0;

        if (!hasFilters) {
          // ✅ ORIGINAL BEHAVIOR: no filters → load more from the collection
          const url = `${this.collectionUrl}?page=${this.currentPage + 1}`;
          window.history.pushState({}, '', url);

          try {
            const listToAppend = await fetch(url).then((response) => response.text());
            const listContainer = document.createElement("div");
            listContainer.innerHTML = listToAppend;

            const result_products = listContainer.querySelectorAll("#product-grid product-card");
            const productPerPage = 32;
            const forloopPosition = productPerPage * this.currentPage + 1;

            result_products.forEach((product, index) => {
              const product_title = product.querySelector(".card-title > a").textContent;
              const product_url = product.querySelector(".card-title > a").href;
              const releated_products = this.availableCollectionJson.products.filter(
                (product) => product.title == product_title
              );
              let numberOfColorMoreThan4 = false;
              const indexOfCurrentProduct = releated_products.findIndex((product) =>
                product_url.includes(product.url)
              );
              let startIndex = 0;
              let endIndex = 0;
              if (indexOfCurrentProduct + 4 < releated_products.length) {
                startIndex = indexOfCurrentProduct;
                endIndex = indexOfCurrentProduct + 4;
              } else {
                startIndex = releated_products.length - 4;
                endIndex = releated_products.length;
              }
              const html = releated_products
                .map((product, innerIndex) => {
                  var colorSwatch = product.metafields;
                  if (colorSwatch.includes("/")) {
                    colorSwatch = colorSwatch.replaceAll(" / ", "-").toLowerCase();
                  } else {
                    colorSwatch = colorSwatch.replaceAll(" ", "-").toLowerCase();
                  }
                  if (innerIndex >= startIndex && innerIndex < endIndex) {
                    return `
                <li>
                  <input type="radio" data-product-handle="${product.handle}"
                    data-product-id="${product.id}"
                    data-url="${product.url}"
                    value="${product.id}"
                    name="${product.title}-${forloopPosition + index}"
                    title="${colorSwatch}"
                    class="visually-hidden"
                    id="prod-${product.id}-${forloopPosition + index}"
                    ${product_url.includes(product.url) ? "checked" : ""}>

                  <label
                    for="prod-${product.id}-${forloopPosition + index}"
                    class="card-bubble--value product-form__value--color ${colorSwatch}"
                    title="${colorSwatch}"
                    aria-label="${colorSwatch}"
                  >
                    <span class="sr-only">${colorSwatch}</span>
                  </label>
                </li>
              `;
                  } else {
                    numberOfColorMoreThan4 = true;
                  }
                })
                .join("");

              product.querySelector(".card-bubbles ul").innerHTML = html;
              if (numberOfColorMoreThan4) {
                const moreColorLink = document.createElement("a");
                moreColorLink.href = product_url;
                moreColorLink.innerHTML = "+ More Colors";
                moreColorLink.classList.add("bubble-more-colors-link");
                product.querySelector(".card-bubbles fieldset").append(moreColorLink);
              }
            });

            const newCollPaginate = listContainer.querySelector("collection-paginate");

            this.currentPage = newCollPaginate.currentPage;
            if (newCollPaginate.prodGrid)
              this.prodGrid.innerHTML += newCollPaginate.prodGrid.innerHTML;
            if (newCollPaginate.paginateIndicator)
              this.paginateIndicator.innerHTML = newCollPaginate.paginateIndicator.innerHTML;

            this.updateViewMoreCount();
          } catch (err) {
            console.error(err);
          }

          return;
        }

        // ✅ NEW BEHAVIOR: filters active → OR-search-based pagination
        const selected = this.activetags || [];
        const searchQuery = selected.map(tag => `tag:${tag}`).join(' OR ');
        const nextPage = this.currentPage + 1;

        const loadMoreBtn = this.paginateIndicator?.querySelector('.paginate-more');
        if (loadMoreBtn) {
          loadMoreBtn.innerHTML = 'Loading...';
        }

        const tmpUrl = `/search?q=${encodeURIComponent(searchQuery)}&type=product&page=${nextPage}&view=ajax`;
        console.log('extendPage tmpUrl', tmpUrl);
        // Don't push state here for search pagination or use correct collection URL if possible
        // window.history.pushState({}, '', tmpUrl); 

        try {
          const html = await fetch(tmpUrl).then(r => r.text());
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;

          // Filter out products not in current collection
          this.filterProductsByCollection(wrapper);

          const newCollection = wrapper.querySelector('#ProductGridContainer .collection');
          if (!newCollection) {
            console.warn('extendPage: no .collection found in ajax response');
            return;
          }

          const newGrid = newCollection.querySelector('#product-grid');
          const newIndicator = newCollection.querySelector('.paginate-indicator');

          if (newGrid && this.prodGrid) {
            this.prodGrid.innerHTML += newGrid.innerHTML;
          }

          if (newIndicator && this.paginateIndicator) {
            this.paginateIndicator.innerHTML = newIndicator.innerHTML;
          }

          this.currentPage = parseInt(newCollection.dataset.currentPage);
          this.totalPages = parseInt(newCollection.dataset.totalPages);

          // keep active chips visible
          this.renderActiveFilters(this.activetags || []);
          this.updateViewMoreCount();
        } catch (err) {
          console.error('extendPage (search) error', err);
        }
      }
    }
  );
}

if (!customElements.get("remove-filter")) {
  customElements.define(
    "remove-filter",
    class RemoveFilter extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.filterValue = this.dataset.filterValue;

        this.parentCollection = document.querySelector("collection-paginate");
        this.addEventListener("click", this.onRemoveFilter.bind(this));
        this.addEventListener("keyup", this.onKeyUpRemoveFilter.bind(this));

        this.filterTabs = document.querySelector("filter-tabs");
      }

      onKeyUpRemoveFilter(e) {
        if (e.keyCode == 32 || e.keyCode == 13) {
          this.onRemoveFilter();
        }
      }

      onRemoveFilter() {
        let updatedFilters = [];
        switch (this.filterValue) {
          case "clear":
            this.parentCollection.activetags = [];
            this.filterTabs
              .querySelectorAll("filter-button.filter-active")
              .forEach((tab) => tab.classList.remove("filter-active"));
            break;
          default:
            this.parentCollection.activetags = this.parentCollection.activetags.filter(
              (tag) => tag !== this.filterValue
            );
            if (this.filterTabs.querySelector(`filter-button[data-value="${this.filterValue}"]`)) {
              this.filterTabs
                .querySelector(`filter-button[data-value="${this.filterValue}"]`)
                .classList.remove("filter-active");
            }
            break;
        }

        this.parentCollection.fetchFilterProdList();

        this.filterTabs.foldActiveContainer();
      }
    }
  );
}
